import React from "react";
import { useMutation, useQueryClient } from "react-query";
import "react-alice-carousel/lib/alice-carousel.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import NoImageFoundDocument from "./noImageFoundDocument";

export default function UnionLoadDocument(props: any) {
  const images = props.data;
  // let isValue = false;
  // if (props.title! == true && props.data) {
  //     isValue = true
  // } else if (props.title! == false && props.data) {
  //     isValue = false
  // }
  return (
    <>
      {images[0] != null ? (
        <div className="UploadImageCmp" style={{ direction: "ltr" }}>
          <>
            {/* <a href={props.data.fileUrl!} target="_blank"> */}
            <Carousel showThumbs={false} showStatus={false} infiniteLoop={true}>
              {images?.map((image: any) =>
                image != undefined && image != null ? (
                  <>
                    <a
                      href={image.fileUrl}
                      target="blank"
                      style={{
                        maxWidth: "fit-content",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={image.fileUrl}
                        style={{ height: "14vh" }}
                        className="uploadImage"
                      />
                    </a>
                  </>
                ) : (
                  <div style={{ height: "14vh" }}>
                    {" "}
                    <NoImageFoundDocument />
                  </div>
                )
              )}
            </Carousel>

            {/* <img src={props.data.fileUrl} className="uploadImage" /> */}
            {/* </a> */}
            <div className="row unionRowUploadImage">
              <div className="col-12 cont" style={{ color: "#fff" }}>
                <p className="paraghramImageUnion infoText">
                  {"تجمیعی"}
                  {props.accumulative.accumulativeAmount.toLocaleString()}
                  {" ریال "}
                </p>
              </div>
            </div>
          </>
        </div>
      ) : (
        <NoImageFoundDocument />
      )}
    </>
  );
}
